import { ComponentModel } from '../../../models';

export const checkIfComponentIsUsedForBilling = (component: ComponentModel) => {
  if (component.pricePoint.id === null) return false;
  if (component.type === 'on_off') return component.enabled;
  if (component.type === 'metered') return component.unit.balance > 0;
  if (['quantity', 'prepaid'].includes(component.type))
    return component.allocatedQuantity > 0;
};
